module.exports = __webpack_public_path__ + "static/media/temp_35.83b906dd.jpg";